import { render } from "./ReturnData.vue?vue&type=template&id=06a199b0&scoped=true"
import script from "./ReturnData.vue?vue&type=script&lang=js"
export * from "./ReturnData.vue?vue&type=script&lang=js"

import "./ReturnData.vue?vue&type=style&index=0&id=06a199b0&scoped=true&lang=css"
import "./ReturnData.vue?vue&type=style&index=1&id=06a199b0&lang=less&scoped=true"

import exportComponent from "D:\\AICodeSpace\\KaungAdmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06a199b0"]])

export default __exports__